export const checklistData = [
  {
    check_point: 'GUIDE BUSH / GUIDE PILLAR CLEARANCE ',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
  },
  {
    check_point: 'ALIGHMENT OF PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
  },
  {
    check_point: 'CLEARANCE BETWEEN PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
  },
  {
    check_point: 'PLAY IN PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
  },
  {
    check_point: 'LOCATORS OR LOCATOR PINS WORKING PROPERLY & LOCATOR MATERIAL',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
  },
  {
    check_point: 'PUNCH & DIE DIMENSION',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
  },
  {
    check_point: 'PUNCH & DIE RADIUS',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
  },
  {
    check_point: 'PUNCH & DIE ANGLE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
  },
  {
    check_point: 'PUNCH & DIE PROFILE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
  },
  {
    check_point: 'EJECTOR MOVEMENT',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
  },
  {
    check_point: 'SCRATCHES ON PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
  },
  {
    check_point: 'PUNCH & DIE HARDNESS',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
  },
  {
    check_point: 'SPRING TENSION',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
  },
  {
    check_point: 'BOLTS ARE TIGHT',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
  },
  {
    check_point: 'DOWEL PINS',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
  },
];

export const Bending = [
  {
    check_point: 'GUIDE BUSH / GUIDE PILLAR CLEARANCE ',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'ALIGHMENT OF PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'CLEARANCE BETWEEN PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PLAY IN PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'LOCATORS OR LOCATOR PINS WORKING PROPERLY & LOCATOR MATERIAL',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH & DIE DIMENSION',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH & DIE RADIUS',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH & DIE ANGLE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH & DIE PROFILE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'EJECTOR MOVEMENT',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'SCRATCHES ON PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH & DIE HARDNESS',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'SPRING TENSION',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'BOLTS ARE TIGHT',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'DOWEL PINS',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
];

export const Draw = [
  {
    check_point: 'GUIDE BUSH / GUIDE PILLAR CLEARANCE ',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'ALIGHMENT OF PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'CLEARANCE BETWEEN PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PLAY IN PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point:
      'SPRING LOCATORS OR LOCATOR PINS WORKING PROPERLY & LOCATOR MATERIAL',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH & DIE DIMENSION',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH & DIE RADIUS',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH & DIE ANGLE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH & DIE PROFILE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'RADIUS OF PUNCH AND DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH DIAMETER & HOLE DIAMETER OF DIE SHOUND NOT BE OVAL',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'EJECTOR MOVEMENT',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'SCRATCHES ON PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH & DIE HARDNESS',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'SPRING TENSION',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'BOLTS ARE TIGHT',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'DOWEL PINS',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
];

export const Fixtures = [];

export const Flatness = [
  {
    check_point: 'GUIDE BUSH / GUIDE PILLAR CLEARANCE ',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'ALIGHMENT OF PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PLAY IN PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH & DIE FLATNESS',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH & DIE PROFILE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH & DIE HARDNESS',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'BOLTS ARE TIGHT',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'DOWEL PINS',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
];

export const Piercing = [
  {
    check_point: 'GUIDE BUSH / GUIDE PILLAR CLEARANCE ',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'ALIGHMENT OF PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'CLEARANCE BETWEEN PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PLAY IN PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point:
      'SPRING LOCATORS OR LOCATOR PINS WORKING PROPERLY & LOCATOR MATERIAL',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'DIE & PUNCH EDGE SURFACE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'SPRING TENSION',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH DIMENSIONS',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PROVIDE HARD BUSH IN PUNCH PLATE ( IF NOT PRESENT) ',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PUNCH GUIDE PLATE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'BOLTS ARE TIGHT',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'DOWEL PINS',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
];

export const Blank = [
  {
    check_point: 'GUIDE BUSH / GUIDE PILLAR CLEARANCE ',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'ALIGHMENT OF PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'CLEARANCE BETWEEN PUNCH & DIE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PLAY IN PUNCH & Guide Plate',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point:
      'SPRING LOCATORS OR LOCATOR PINS WORKING PROPERLY & LOCATOR MATERIAL',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'DIE & PUNCH EDGE SURFACE',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'SPRING TENSION',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'PROVIDE HARD BUSH IN PUNCH PLATE ( IF NOT PRESENT) ',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'BOLTS ARE TIGHT',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
  {
    check_point: 'DOWEL PINS',
    mode_of_inspection: 'Visual',
    obs: '',
    status: '',
    specification: '',
  },
];
